/* eslint-disable i18n/no-russian-character */
const ruPipes = {
    analyticType: {
        revenue: "Выручка",
        averageReceipt: "Средний чек",
        receiptsQuantity: "Количество чеков",
        mobileApp: "Мобильное приложение",
        discrepancyIndex: "Индекс несоответствия",
        qualityScores: "Баллы несоответствия – общие",
        technicalQualityScores: "Баллы несоответствия – тех.состояние",
        complaintIndex: "Индекс жалоб",
        gratitudeIndex: "Индекс благодарностей",
        tagsRating: "Рейтинг тегов",
        writeOffCount: "Списания",
        writeOffActs: "Недостача",
    },
    clientAddBonusType: {
        add: "Прибавить",
        equal: "Дополнить до значения",
    },
    clientBonusStatus: {
        failed: "Неудача",
        success: "Выполнено",
    },
    clientCategory: {
        base: "Обычный",
        blacklist: "Черный список",
        scammer: "Мошенник",
        suspect: "Подозрительный",
        vip: "VIP",
    },
    contactType: {
        email: "E-mail",
        phone: "Телефон",
        telegram: "Telegram",
    },
    documentFieldSynchronizeType: {
        birthDate: "Дата рождения",
        firstName: "Имя",
        lastName: "Фамилия",
        middleName: "Отчество",
        no: "Не синхронизировать",
        sex: "Пол",
    },
    documentProcessingAction: {
        confirm: "Подтвердить",
        edit: "Редактировать",
    },
    documentProcessingActionUserType: {
        currentUser: "Пользователь",
        hr: "Отдел кадров",
        manager: "Руководитель",
    },
    documentStatus: {
        checkout: "На проверке",
        checkoutHr: "На проверке отдела кадров",
        checkoutManager: "На проверке менеджера",
        notCreated: "Новый",
        success: "Подтвержден",
    },
    documentTemplate: {
        passport: "Паспорт",
        medicalBook: "Мед. книжка",
        inn: "ИНН",
        snils: "СНИЛС",
    },
    employeeHistoriesAction: {
        department: "Перевод",
        dismiss: "Увольнение",
        employee: "Смена должности",
        employeeAndDepartment: "Перевод и смена должности",
        hiring: "Прием на работу",
        employeeChangeOfficial: "Смена оф. статуса",
        blackListAdd: "Добавление в черный список",
        blackListRemove: "Удаление из черного списка",
        changeRate: "Изменение размера ставки",
    },
    employeeHistoryReasonTypeCategory: {
        company: "Компания",
        employee: "Сотрудник",
    },
    employeeHistoryReasonType: {
        other: "Другое",
        lowIncome: "Низкий уровень дохода",
        betterJobOffer: "Нашёл(ла) работу с лучшими условиями",
        unsuitableSchedule: "Неудобный график / не подходит сменность",
        educationConflict: "Невозможно совмещать с учёбой",
        personalCircumstances: "Личные обстоятельства (переезд, семья, здоровье, армия, декрет)",
        temporaryEmployment: "Временная занятость (сезон / подработка)",
        expectationMismatch: "Работа не подошла / не соответствует ожиданиям",
        highWorkloadUnready: "Не готов к нагрузке / темпу работы",
        jobAbandonment: "Самовольно прекратил работу (невыходы, пропал, ушёл без отработки)",
        probationFailed: "Не прошёл стажировку / не вышел на стажировку",
        underperformance: "Не справляется с обязанностями",
        lowQualityOfWork: "Низкое качество работы / системные ошибки",
        absenteeism: "Систематические невыходы / прогулы",
        tardiness: "Опоздания / нарушение графика",
        serviceStandardViolation: "Нарушение стандартов работы / сервиса",
        insubordination: "Нарушение дисциплины / субординации / отказ выполнять требования",
        toxicBehavior: "Конфликты / токсичное поведение / грубость",
        financialMisconduct:
            "Материальные нарушения (недостача, кража, мошенничество, злоупотребления)",
        noContact: "Потеря контакта (не выходит на связь)",
    },
    externalResourceStatus: {
        pending: "На рассмотрении",
        approved: "Одобрено",
        denied: "Отказано",
    },
    filterDateEquals: {
        equals: "Равно",
        less: "<=",
        more: ">=",
        notEquals: "Не равно",
    },
    filterNumberEquals: {
        contains: "Содержит",
        equals: "Равно",
        less: "<=",
        more: ">=",
        notContains: "Не содержит",
        notEquals: "Не равно",
    },
    filterTextEquals: {
        contains: "Содержит",
        endWith: "Заканчивается на",
        equals: "Равен",
        isClear: "Нет значения",
        isNotClear: "Есть значение",
        notContains: "Не содержит",
        startWith: "Начинается с",
    },
    gradeExpirationWarningType: {
        examination: "Пройдите назначенную аттестацию",
        gradeStep: "Пройдите шаг грейда",
        lesson: "Пройдите назначенный урок",
    },
    gradeHistoryType: {
        annulated: "Аннулирован",
        passed: "Получен",
    },
    gradeStepStatus: {
        expired: "Время истекло",
        failed: "Провален",
        inProgress: "В процессе",
        needToRepass: "Нужно пройти",
        new: "Новый",
        passed: "Пройден",
        waitingConfirm: "Ожидает подтверждения",
    },
    gradeUserStatus: {
        active: "Получен",
        blocked: "Заблокирован",
        failed: "Нужно пройти",
        warnings: "Обратите внимание",
    },
    hrVacancyScheduleType: {
        dayStandart: "Дневные смены (с 08:00 до 20:00)",
        nightStandart: "Ночные смены (с 20:00 до 08:00)",
        half: "Неполные смены (с 19:00 до 00:00)",
    },
    hrVacancyStatus: {
        created: "На рассмотрении HR",
        active: "Активна",
        notActive: "Отложена",
    },
    ingredientType: {
        finished: "Продукт",
        raw: "Сырье",
        semiFinished: "Полуфабрикат",
    },
    initiatorType: {
        assigned: "Назначено",
        self: "Самостоятельно",
        system: "Система",
    },
    innerLearningActivityStatus: {
        cancelled: "Отменено",
        notReady: "Ожидает выполнения",
        ready: "Выполнено",
    },
    innerLearningAttestationStatus: {
        cancelled: "Провалена",
        complete: "Пройдена",
        notComplete: "Ожидает выполнения",
    },
    innerLearningPersonPlanStatus: {
        cancelled: "Отменено",
        confirmed: "Подтверждено",
        waiting: "Ожидает подтверждения",
    },
    journalAssignmentStatus: {
        completed: "Заполненный",
        new: "Доступный",
    },
    journalQuestionType: {
        date: "Дата",
        image: "Фото",
        number: "Число",
        select: "Список",
        text: "Текст",
        yesNo: "Да/Нет",
    },
    learningErrorFeedbackStatus: {
        active: "Новая",
        canceled: "Отменено",
        completed: "Исправлено",
    },
    lessonConfirmType: {
        admin: "Администратором",
        manager: "Менеджером",
        no: "Не требуется",
    },
    iikoCashshiftCashOutType: {
        cashPickUp: "Инкассация в центральную кассу",
        correctPayment: "Пересорт",
        totalPickUp: "Подтверждение инкассации",
        totalCorrectPayment: "Итоговое подтверждение",
    },
    lessonLearnSessionStatus: {
        completed: "Завершено",
        created: "Назначено",
        expired: "Истекло",
        failed: "Провалено",
        inProgress: "В процессе",
        terminated: "Отменено",
        waitingConfirm: "Ожидает подтверждения",
    },
    lessonStepType: {
        common: "Информационный",
        multiTest: "Мульти-тест",
        poll: "Опрос",
        rightOrder: "Правильный порядок",
        test: "Тест",
        textAnswer: "Текстовый ответ",
    },
    messageStatus: {
        failed: "Ошибка",
        new: "Новое",
        none: "Отключен",
        readed: "Прочитано",
    },
    mobileAppPointType: {
        bakery: "Пекарня",
        bodry: "Бодрю",
        coffemachine: "Автокафе",
        crossCulture: "Кросс-культура",
        island: "Кофе-остров",
        none: "Нет",
    },
    monthDefault: {
        all: "Все",
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь",
    },
    offenseType: {
        concomitant: "Сопутствующее",
        main: "Основное",
    },
    okkComplaintStatus: {
        feedbackClarification: "На уточнении",
        inProgress: "В работе",
        inProgressByInspector: "В работе у инспектора",
        inProgressByManager: "В работе у менеджера",
        notProcessed: "Необработанно",
        processed: "Обработано",
        processedWithOffense: "Обработано c нарушениями",
        protest: "Опротестовано",
        waitingDecision: "Ожидает решения",
    },
    okkComplaintGuestCommunicationRating: {
        positive: "Положительная",
        neutral: "Нейтральная",
        negative: "Негативная",
    },
    okkQualitySurveyStatus: {
        failed: "Провалено",
        inProgress: "В процессе",
        notProcessed: "Необработанно",
        successed: "Выполнено",
    },

    okkSourceType: {
        email: "Электронная почта",
        instagram: "Instagram",
        mobileApp: "Мобильное приложение",
        other: "Прочие источники поступления обращения",
        phone: "Телефон",
        qCCheckList: "Чек-лист ОУК",
        secretVisits: "Проверка тайным гостем",
        stp: "Проверка",
        telegram: "Telegram",
        tradePointCheckList: "Чек-лист кофейни",
        video: "Видео",
        videoServiceControl: "Сервис видеонаблюдения",
        whatsApp: "WhatsApp",
        maxApp: "Мессенджер Max",
    },
    okkSourceTypeTitle: {
        email: "Жалоба по электронной почте",
        instagram: "Жалоба из Instagram",
        mobileApp: "Отзыв из мобильного приложения",
        other: "Обращение",
        phone: "Жалоба из телефонного звонка",
        qCCheckList: "Чек-лист ОУК",
        secretVisits: "Проверка тайным гостем",
        stp: "Проверка",
        telegram: "Жалоба из Telegram",
        tradePointCheckList: "Чек-лист",
        video: "Жалоба из видео",
        videoServiceControl: "Жалоба из сервиса видео-наблюдения",
        whatsApp: "Жалоба из WhatsApp",
        maxApp: "Жалоба из мессенджера Max",
    },
    operationalReportType: {
        tradePoint: "Сводный отчет по кофейне",
        salePlan: "План продаж",
    },
    permissions: {
        camera: "Доступ к камере",
        notifications: "Доступ к уведомлениям",
    },
    pntrCompanyStatusType: {
        open: "Открыт",
        closed: "Закрыт",
        temporarilyClosed: "Временно закрыт",
    },
    pollItemType: {
        list: "Список",
        multiList: "Список ( несколько вариантов )",
        rating: "Рейтинг",
        slider: "Число от до",
        text: "Текст",
    },
    pollType: {
        base: "Базовый",
        noInstance: "Без назначения",
        nPS: "NPS",
        qCCheckList: "Чек-лист ОУК",
    },
    preOrderCancelReason: {
        cancelInAppOrPhone: "Отменил",
        didntPickUp: "Не забрал",
    },
    reportList: {
        okkComplaintsOnCommission: "Повестка к Комиссии",
        feedbackIndexes: "Отчет по индексам обратной связи гостей",
        forPeriodOffences: "Отчет по нарушениям",
        forQuarterTechnicalOffences: "Отчет по повторяющимся техническим нарушениям за квартал",
        forOkkProcessedComplaints: "Отчет по обработанным обращениям",
        forCountOkkComplaints: "Отчет по обращениям гостей в разрезе категорий",
        forPeriodPreOrderCancels: "Отчёт по отменам предзаказов",
        forOkkGuestCommunication: "Сводный отчет по удовлетворенности гостей",
        forPeriodRating: "Отчет по оценкам мобильного приложения",
        forPeriodMobile: "Отчет по рейтингу мобильного приложения",
        tradePointCheckLists: "Отчет по чек-листам кофейни",
        completedQCCheckLists: "Отчет по чек-листам ОУК",
        statusLog: "Отчет по времени статусов обращений",
        discrepancyIndexExcel: "Отчет по индексам несоответствия",
        generalViolations: "Общий отчет по нарушениям",
        hrStaffLevels: "Отчет по укомплектованности персонала",
        adminsUsersGrades: "Получение грейдов Офис",
        assignedLessonsResultEmployee: "Прохождение назначенных уроков работниками кофеен",
        gradeLessonsResultEmployee: "Прохождение грейдовых уроков работниками кофеен",
        gradeTreeLessons: "Наполненность грейдов уроками",
        lessonPollsResult: "Отчет по опросам в уроках",
        lessonsResultOfficeWorkers: "Прохождение уроков офисными сотрудниками",
        tradePointsRolesGrades: "Грейды по кофейням",
        tradePointsUsersGrades: "Получение грейдов",
        consultationSurvey: "Опросник по консультации (Ответы)",
        internshipSurvey: "Опросник по практической стажировке (Ответы)",
        studentEventsSurvey: "Опросник по прошедшему мероприятию от студента (Ответы)",
        usersGrades: "Грейды сотрудников",
        managersWithoutGrade: "Менеджеры без грейда",
        articleUnreadUsers: "Отчет по непрочитанным статьям",
        documentMedicalBookReport: "Отчет по медицинским книжкам",
        documentUser: "Отчет о кадровой информации",
        clientsBonus: "Отчет по начислениям бонусов",
        clientsCategory: "Отчет по типам гостей",
        operationalTradePointSummary: "Сводный отчет по кофейне",
        operationalSalePlan: "План продаж",
        sdReport: "Сводный отчет по обращениям",
        oukComments: "Отчет по комментариям ОУК",
    },
    sortOrder: {
        asc: "По возрастанию",
        desc: "По убыванию",
    },
    qCCheckListComplaintCreationMode: {
        auto: "Автоматически",
        manual: "Вручную",
    },
    qCCheckListItemEvaluationStatus: {
        new: "Новый",
        nok: "С нарушениями",
        ok: "Без Нарушений",
        suspicious: "Под вопросом",
    },
    qCCheckListPenalizationType: {
        checkList: "Весь чек-лист",
        item: "Каждый пункт",
    },
    qCCheckListStatus: {
        evaluationFinished: "Обработан",
        evidenceCollected: "На оценке",
        new: "Для заполнения",
    },
    roleTypes: {
        Employees: "Работник кофейни",
        ManyTradePoints: "Другое",
        NoTradePoints: "Работник УК",
        FabricWorkers: "Работник ФК",
    },
    sdClaimStatus: {
        closed: "Закрыта",
        inProgress: "В работе",
        new: "Новая",
        waitingBefore: "Отложена до",
        waitingClose: "Ожидает закрытие",
    },
    sdServiceType: {
        claim: "По заявкам",
        contract: "По договору",
    },
    scheduledTaskStatus: {
        pending: "Ожидает выполнения",
        succeeded: "Выполнено успешно",
        failed: "Завершено с ошибкой",
    },
    scheduledTaskType: {
        custom: "Пользовательская",
        userDismissing: "Увольнение пользователя",
        tradePointLegalPerson: "Смена юридического лица кофейни",
    },
    statisticPeriod: {
        day: "День",
        month: "Месяц",
        year: "Год",
        custom: "Период",
    },
    statisticFilterCompareType: {
        planFact: "План-Факт",
        otherTradePoints: "C другой кофейней",
        otherDatePeriod: "C другим периодом",
        monthPrev: "К прошлому месяцу",
        monthPrevByDays: "К прошлому месяцу (на аналогичное число)",
        monthPrevYear: "Этот месяц годом ранее",
        monthPrevAverage: "К прошлому месяцу (среднедневное)",
        yearPrev: "К прошлому году",
        yearPrevByDays: "К прошлому году (на аналогичное число)",
        dayPrevWeek: "Этот день на предыдущей неделе",
        dayPrevMonthAverage: "Этот день недели со средним днем недели за предыдущий месяц",
        dayPrevYear: "Этот день годом ранее",
    },
    statisticType: {
        revenue: "Выручка",
        countOfChecks: "Количество чеков",
        averageCheck: "Средний чек",
        mobileApplication: "Мобильное приложение",
        gratitudeIndex: "Индекс благодарностей",
        complaintIndex: "Индекс жалоб",
        nonConformityPointsGeneral: "Баллы несоответствия – общие",
        nonConformityPointsTechnicalCondition: "Баллы несоответствия – тех.состояние",
    },
    surveyQuestionType: {
        image: "Фото",
        imageFile: "Фото из галереи",
        list: "Список",
        text: "Текст",
        video: "Видео",
        videoFile: "Видео из галереи",
        yesNo: "да/нет",
    },
    surveyStatus: {
        completed: "Завершен",
        created: "Назначен",
        failed: "Провален",
        inProgress: "В процессе",
    },
    tableLogTableName: {
        operationCard: "КСО",
    },
    tagsContext: {
        okkComplaint: "Обращения",
    },
    thirdPartyReportShowCategory: {
        operationalReport: "Операционные отчеты",
        speed: "Отчеты по скорости сервиса",
        ukReport: "Отчеты УК",
        main: "Отчеты по качеству",
    },
    tradePointBrand: {
        coffeeMachine: "Кофе Машина",
        crossCulture: "Кросс Культура",
        invigorate: "Бодрю",
        yaiThai: "Яй Тай",
    },
    tradePointEmployeeType: {
        tradePoint: "Кофейня",
        cookFactory: "Производство",
        uk: "Управляющая компания",
    },
    tradePointFormat: {
        autocafe: "Автокафе",
        cafe: "Кафе",
        coffeeIsland: "Кофе-остров",
        foodCourt: "Фудкорт",
        foodTruck: "Фуд-трак",
        stop: "Остановка",
    },
    tradePointFiscalDataType: {
        fN: "ФН",
        oFD: "ОФД",
    },
    tradePointOwnerType: {
        franchise: "Франшиза",
        onControl: "Под управлением",
        own: "Под полным управлением",
        uk: "Управляющая компания",
    },
    ukReportType: {
        eNPSReport: "Отчет по опросу ENPS",
    },
    userBonusWithProblemType: {
        needBonus: "Нужно добавить",
        notNeedBonus: "Нужно убрать",
    },
    userRole: {
        academy: "Сотрудник Академии",
        barista: "Бариста",
        baristaAssistant: "Помощник бариста",
        chiefInspector: "Ведущий инспектор",
        commonEmployee: "Универсал",
        cook: "Повар",
        dutyOperator: "Дежурный оператор",
        externalEvidenceCollector: "Внештатный сборщик фото",
        franchisee: "Франчайзи",
        inspector: "Инспектор",
        managerAssistant: "Кассир",
        marketer: "Маркетолог",
        officeWorker: "Офисный сотрудник",
        operatingDirector: "Операционный директор",
        portalAdministrator: "Администратор портала",
        producer: "Заготовщик",
        probationer: "Стажер",
        shiftSupervisor: "Старший смены",
        steward: "Официант",
        technologist: "Технолог",
        territorialDirector: "Территориальный директор",
        tradePointManager: "Менеджер",
        tradePointTablet: "Планшет кофейни",
        ukLeader: "Руководитель УК",
        fabricWorker: "Управляющий ФК",
        employeeFabricWorker: "Линейный сотрудник ФК",
    },
    userBlackListReasonType: {
        other: "Другое",
        theft: "Кража денежных средств или товара",
        fraud: "Мошенничество (касса, чеки, смены)",
        intentionalShortage: "Умышленная недостача",
        forgery: "Подлог документов / данных",
        unjustifiedAbsence: "Прогул без уважительной причины",
        desertion: "Самовольный уход со смены",
        safetyOrSanitationViolation:
            "Грубое нарушение кассовых, санитарных норм или техники безопасности",

        aggressiveBehavior: "Агрессивное, токсичное или угрожающее поведение",
        reputationalDamage: "Действия, наносящие репутационный ущерб компании",
    },
    userSex: {
        female: "Женский",
        male: "Мужской",
        unknown: "Не указан",
    },
    userStatus: {
        dismissed: "Уволен",
        working: "Работает",
    },
    vacancyTitle: {
        barista: "Бариста",
        baristaAssistant: "Помощник бариста",
        cook: "Повар",
        cashier: "Кассир",
        manager: "Менеджер",
        shiftSupervisor: "Старший смены",
        steward: "Официант",
        probationer: "Стажер",
        producer: "Заготовщик",
    },
    equipmentStatus: {
        active: "Активное",
        inactive: "Неактивное",
        underMaintenance: "На обслуживании",
        retired: "Списано",
        lost: "Утеряно",
    },
    ingredientCategoryType: {
        semiFinished: "Полуфабрикаты",
        products: "Товары",
        packaging: "Упаковка",
        householdExpenses: "Хозяйственные расходы",
    },
    maintenanceType: {
        preventive: "Тех. обслуживание",
        repair: "Ремонт",
        replacement: "Замена",
        inspection: "Осмотр",
    },
    workManagerEventStatus: {
        employee: "Желаемое",
        manager: "Назначено",
        approved: "Согласовано",
        review: "На проверке",
        completed: "Выполнено",
        excusedAbsence: "Отменено",
        unexcusedAbsence: "Прогул",
        doNotDisturb: "Занят",
    },
    workManagerPayrollFine: {
        medicalCheckup: "Мед. комиссия",
        cashShortage: "Недостача по кассе",
        training: "Обучение",
        parking: "Парковка",
        staffMeals: "Питание персонала",
        employeeDamage: "Порча по вине сотрудников",
        workshopProduction: "Продукция цеха",
        otherExpenses: "Прочие расходы (путешествие и т.д.)",
        travel: "Путешествия",
        inventoryAudit: "Ревизия (инвентаризация)",
        uniform: "Форма",
        employeeFines: "Удержания",
    },
    workManagerPayrollStatus: {
        created: "На проверке",
        finished: "Утверждена",
        canceled: "Отменена",
    },
    innerLearningPlanAccountingStatus: {
        waiting: "Ожидает согласования",
        approved: "Согласовано",
        cancelled: "Отменено",
    },
    innerLearningSurveyInitiatorType: {
        coach: "Наставник",
        student: "Студент",
    },
    gptModels: {
        gpt41: "Чат GPT 4.1",
        o3Mini: "Чат GPT o3 mini",
        gpt5Mini: "Чат GPT 5 mini",
        dallE: "Dall-e",
        o1: "Чат GPT o1",
        gpt5: "Чат GPT 5",
        auto: "Auto (OpenRouter)",
    },
};

export default ruPipes;
